module.exports = __webpack_public_path__ + "media/images/japan/carousel-arrow-8e4e73e902739aaf4cdaf12de85c3db8.svg";